import { render, staticRenderFns } from "./ManageSelection.vue?vue&type=template&id=47e9116d&"
import script from "./ManageSelection.vue?vue&type=script&lang=js&"
export * from "./ManageSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports